<template>
  <section class="app-section-base app-job-details">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-primary" v-if="id == 1">
            <div class="panel-heading">
              <h4 class="panel-title">
                <i class="fa fa-file-text-o"></i>Care Service Manager - Job
                Description
              </h4>
            </div>
            <div>
              <div class="panel-body">
                <p><b>Job Title : </b> Care Service Manager</p>
                <p>
                  <b>Job Purpose:</b><br />
                  The role will be to support with the smooth running and
                  provide management skills covering our services across 5
                  locations.
                </p>
                <hr />
                <b>The duties will be but not limited to the following:</b
                ><br /><br />
                <ul class="fa-ul">
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Manage budgets,
                    contracts and financial effectiveness of our settings.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Recruit, hiring and
                    carry out on boarding of staff using SAP HCM software.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Assess new referrals
                    and carry out inductions.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Maintain quality
                    standards and ensure health and safety compliance.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Chair meetings and
                    deliver trainings and keeping accurate recordings.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Ensure the delivery
                    of quality, person centred care.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Ensure regulatory
                    activities such as personal care, administering medicines is
                    delivered within regulations.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Organise activities
                    for residents.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Promote the
                    organization in a healthy positive manner.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Overseeing day to
                    day running of the care service.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Assessing patient
                    care systems.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Meeting with patient
                    families and friends.
                  </li>
                </ul>
                <hr />
                <b>Essential experience and qualifications:</b><br /><br />
                <ul class="fa-ul">
                  <li>
                    <i class="fa-li fa fa-asterisk"></i>Minimum 3 years'
                    experience in management or project management experience.
                  </li>
                  <li>
                    <i class="fa-li fa fa-asterisk"></i>Minimum 2 years'
                    experience in SAP HCM.
                  </li>
                  <li>
                    <i class="fa-li fa fa-asterisk"></i>Good knowledge in time
                    management, cost and budget estimations.
                  </li>
                  <li>
                    <i class="fa-li fa fa-asterisk"></i>A health qualification
                    will be to an advantage or willing to work towards the
                    qualification.
                  </li>
                </ul>
                <hr />
                <b>
                  While this Job Description is comprehensive, it may not cover
                  every aspect of the role. <br />
                  Duties may change from time to time as agreed by OTANG CARE LTD.
                </b>
              </div>
            </div>
          </div>

          <div class="panel panel-primary" v-if="id == 2">
            <div class="panel-heading">
              <h4 class="panel-title">
                <i class="fa fa-file-text-o"></i>Senior Support Team Leader -
                Job Description
              </h4>
            </div>
            <div>
              <div class="panel-body">
                <p><b>Job Title : </b> Senior Support Team Leader</p>
                <p>
                  <b>Job Purpose:</b><br />
                  The role will be to help supervise a team of support workers
                  in our service across 5 locations.
                </p>
                <hr />
                <b>The duties will be but not limited to the following:</b
                ><br /><br />
                <ul class="fa-ul">
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Supervise the
                    activities of daily living and personal care support being
                    delivered.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Complete monthly
                    supervision of support workers and appraisals.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Conduct spot checks
                    on support workers.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Complete reviews and
                    assessments when required.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Liaise with GP,
                    Pharmacy to ensure medication is reviewed and ordered.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Reporting any issues
                    to the management team.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Audit and maintain
                    records of daily activities, observations, and finances of
                    service users.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Ensure service is
                    delivered in accordance with all relevant policies,
                    procedures and practices.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Carry out duties as
                    assigned by the Manager
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Attend induction,
                    in-house training sessions and staff meetings.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Complete and audit
                    medication records
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Supervise patient
                    hygiene, elimination and mobility, physical comfort, eating
                    and drinking whilst observing and reporting specific
                    changes.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>First point of
                    contact first aider and able to perform basic life support.
                  </li>

                  <li>
                    <i class="fa-li fa fa-check-square"></i>Contributing new
                    ideas to the team to improve patient care.
                  </li>

                  <li>
                    <i class="fa-li fa fa-check-square"></i>Safeguard service
                    users from harm and abuse: Implement Health and Safety
                    Guidelines, Write and Update care plans.
                  </li>
                </ul>
                <hr />
                <b>Essential experience and qualifications:</b><br /><br />
                <p>
                  Training specific to the role will be provided due to the
                  specialist nature of service to include Autism training,
                  Mental health awareness, Section 117 aftercare – however if
                  candidate has below mentioned training this would be
                  desirable.
                </p>
                <ul class="fa-ul">
                  <li>
                    <i class="fa-li fa fa-asterisk"></i>NVQ level 3, A Level or
                    equivalent.
                  </li>
                  <li>
                    <i class="fa-li fa fa-asterisk"></i>Care certificate or
                    working towards.
                  </li>
                  <li>
                    <i class="fa-li fa fa-asterisk"></i>Nursing Aid Certificate.
                  </li>
                  <li>
                    <i class="fa-li fa fa-asterisk"></i>Diploma in Social
                    Sciences desirable.
                  </li>

                  <li>
                    <i class="fa-li fa fa-asterisk"></i>Caring experience in a
                    professional or personal role.
                  </li>
                  <li>
                    <i class="fa-li fa fa-asterisk"></i>Excellent leadership
                    skills transferrable to role.
                  </li>
                </ul>
                <hr />
                <b>
                  While this Job Description is comprehensive, it may not cover
                  every aspect of the role. <br />
                  Duties may change from time to time as agreed by OTANG CARE LTD.
                </b>
              </div>
            </div>
          </div>

          <div class="panel panel-primary" v-if="id == 3">
            <div class="panel-heading">
              <h4 class="panel-title">
                <i class="fa fa-file-text-o"></i>Care Assistants and Support
                Workers - Job Description
              </h4>
            </div>
            <div>
              <div class="panel-body">
                <p>
                  <b>Job Title : </b> Care Assistant / Support Worker<br />
                  <b>Hourly Pay rate :</b> Between &pound;9.00 - &pound;10.50
                  Pro rata depending on experience<br />
                  <b>Reports to : </b> Registered Manager
                </p>
                <p>
                  <b>Job Purpose:</b><br />
                  To provide care and support to OTANG CARE Service Users in
                  line with the company's aim to provide a high quality,
                  <br />
                  reliable support service tailored to suit each of our Service
                  Users' individual care plans and to promote their independence
                  and choice.
                </p>
                <hr />
                <b>Your role as a OTANG CARE will include:</b><br /><br />
                <ul class="fa-ul">
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Enabling people to
                    remain safe and well in their own home.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Assisting people to
                    live as independently as possible within their own home.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>To provide a range
                    of care and support that may include personal care,
                    promoting and enabling choice in the support provided.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>To support people to
                    live a full life that involves them in activities of daily
                    living such as shopping, meal preparation,<br />
                    light household duties, using leisure amenities e.g. cinema,
                    swimming, public transport, pubs. These are examples only as
                    the list is extensive.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Caring for people
                    who are dying at home where that is their choice.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>To work flexibly to
                    meet the needs of the people being supported in ways that
                    encourages and promotes their <br />independence within
                    their homes and their communities.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>To assist in planned
                    and unplanned care and support.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>To promote equality
                    of opportunity and fairness of outcome for the people
                    receiving the care and support.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>To keep accurate
                    records of the care and support provided.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Supporting people if
                    they are in hospital, and with health appointments.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i>Supporting people to
                    be on holiday.
                  </li>
                </ul>
                <hr />
                <b>The post holder will be required to:</b><br /><br />
                <ul class="fa-ul">
                  <li>
                    <i class="fa-li fa fa-asterisk"></i>Have the essential
                    qualifications which include the Care Certificate
                  </li>
                  <li>
                    <i class="fa-li fa fa-asterisk"></i>Be an excellent
                    communicator, including written skills and the ability to
                    assess and feedback to other professionals.
                  </li>
                  <li>
                    <i class="fa-li fa fa-asterisk"></i>To work on a flexible
                    rota including evenings and weekends in line with the
                    service demands.
                  </li>
                  <li>
                    <i class="fa-li fa fa-asterisk"></i>To attend staff meetings
                    and training relevant to their post.
                  </li>
                  <li>
                    <i class="fa-li fa fa-asterisk"></i>To work with colleagues
                    and the person you support in a respectful way,
                    acknowledging their skills and gifts and <br />dealing with
                    differences in a safe and non-threatening way.
                  </li>
                  <li>
                    <i class="fa-li fa fa-asterisk"></i>To familiarise yourself
                    with and work within OTANG CARE LTD policies and procedures.
                  </li>
                  <li>
                    <i class="fa-li fa fa-asterisk"></i>To promote equality and
                    opportunity and fairness of outcome for staff.
                  </li>
                  <li>
                    <i class="fa-li fa fa-asterisk"></i>To work as part of a
                    team providing support.
                  </li>
                  <li>
                    <i class="fa-li fa fa-asterisk"></i>To manage risk
                    appropriately within the service.
                  </li>
                  <li>
                    <i class="fa-li fa fa-asterisk"></i>To behave reliably and
                    act openly and honestly in all aspects of the job.
                  </li>
                  <li>
                    <i class="fa-li fa fa-asterisk"></i>To take the lead on
                    shifts and provide on call cover from time to time.
                  </li>
                </ul>
                <hr />
                <b>
                  While this Job Description is comprehensive, it may not cover
                  every aspect of the role. <br />
                  Duties may change from time to time as agreed by OTANG CARE LTD.
                </b>
              </div>
            </div>
          </div>

          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">
                <i class="fa fa-file-text-o"></i>Core Values expected of our
                staff:
              </h4>
            </div>
            <div>
              <div class="panel-body">
                <p>
                  As a staff member of <b>OTANG CARE LTD</b>, we will expect you
                  to:
                </p>
                <ul class="fa-ul">
                  <li>
                    <i class="fa-li fa fa-check-square"></i><b>Protect</b> the
                    rights and promote the interests of our citizens and fellow
                    colleagues.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i><b>Strive</b> to
                    establish and maintain the trust and confidence of our
                    citizens.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i><b>Promote</b> the
                    independence of our citizens while protecting them as far as
                    possible from danger and harm.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i><b>Respect</b> the
                    rights of citizens while seeking to ensure that their
                    behaviour does not harm them or others.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i><b>Uphold</b> public
                    trust and confidence in social care services.
                  </li>
                  <li>
                    <i class="fa-li fa fa-check-square"></i
                    ><b>Be accountable</b> for the quality of their work and
                    take responsibility for maintaining and improving their
                    knowledge and skills.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">
                <i class="fa fa-user"></i>Person Specification
              </h4>
            </div>
            <div>
              <div class="panel-body">
                <table class="table table-striped">
                  <thead>
                    <tr class="active">
                      <th>Area</th>
                      <th>Criteria</th>
                      <th>Essential</th>
                      <th>Desirable</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        Physical Characteristics
                      </td>
                      <td>
                        Good standard of appearance as befits dealing with
                        members of the public, patients, and practice staff. A
                        uniform will be provided and should be worn at all times
                        whilst at work
                      </td>
                      <td style="text-align:center;">
                        <span
                          style="font-size:20px;"
                          class="fa fa-check"
                        ></span>
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        Personal Attributes
                      </td>
                      <td>
                        Commitment to the well-being of Service Users Good
                        inter-personal skills Honest and reliable Commitment to
                        maintaining high standards of care and support To
                        maintain Continues Professional Development
                      </td>
                      <td style="text-align:center;">
                        <span
                          style="font-size:20px;"
                          class="fa fa-check"
                        ></span>
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        Personal Qualities
                      </td>
                      <td>
                        A Care Certificate qualification /NVQ Level 2 in Health
                        and Social Care or equivalent. (or achieve within 12
                        months) Verbal communication skills in English. Simple
                        numeracy skills Ability to work with people with
                        personal care support needs Ability to enable people do
                        things for themselves Ability to enable people regain or
                        maintain basic living skills Ability to respond flexibly
                        to the changing needs of Service Users Ability to work
                        on own initiative
                      </td>
                      <td style="text-align:center;">
                        <span
                          style="font-size:20px;"
                          class="fa fa-check"
                        ></span>
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td rowspan="4">
                        Knowledge
                      </td>
                      <td>
                        Basic understanding of supporting vulnerable adults in
                        their own homes. Knowledge of Health and Safety issues.
                      </td>
                      <td style="text-align:center;">
                        <span
                          style="font-size:20px;"
                          class="fa fa-check"
                        ></span>
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        Experience of supporting people with personal and
                        home-based tasks. This can include unpaid support, for
                        example caring for children or other family members
                      </td>
                      <td style="text-align:center;"></td>
                      <td>
                        <span
                          style="font-size:20px;"
                          class="fa fa-check"
                        ></span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Understanding of issues facing older people, especially
                        when living alone.
                      </td>
                      <td style="text-align:center;"></td>
                      <td>
                        <span
                          style="font-size:20px;"
                          class="fa fa-check"
                        ></span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Understanding of confidentiality and privacy
                      </td>
                      <td style="text-align:center;"></td>
                      <td>
                        <span
                          style="font-size:20px;"
                          class="fa fa-check"
                        ></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">
                <i class="fa fa-pencil-square-o"></i>APPLY ONLINE
              </h4>
            </div>
            <div>
              <div class="panel-body">
                <p>
                  Complete the application form below and make sure all
                  questions marked as required are filled-in.<br />
                  A copy of the completed online application form will be sent
                  to your e-mail address, so please check that your e-mail
                  address is correct.<br />
                  Click the submit button when you have finished completing the
                  form.<br />
                  We will review your application and contact you within three
                  working days.
                </p>               
                <application-form></application-form>                
              </div>
            </div>
          </div>

          <div class="panel panel-primary">
            <div class="panel-heading" role="tab" id="headingTwo">
              <h4 class="panel-title">
                <i class="fa fa-download"></i>Download Application Pack
              </h4>
            </div>
            <div>
              <div class="panel-body">
                <div class="row">
                  <div class="col-sm-6">
                    <p>
                      To apply for this job, you may download and complete the
                      application pack and e-mail to
                      <span style="color:#0094ff;">info@otangcare.com</span>
                      or upload the completed file @
                      <router-link to="/secure-upload"
                        >Upload Documents</router-link
                      >
                    </p>
                  </div>
                  <div
                    class="col-sm-6 wow rollIn center"
                    data-wow-duration="1s"
                    data-wow-delay="1s"
                  >
                    <div class="file-download-app-pack">
                      <div class="file-download-app-pack-title">
                        Application pack
                      </div>
                      <span
                        class="file-download-app-pack-span fa fa-file-pdf-o"
                      ></span
                      ><br />
                      <a
                        href="/home/download?filename=OtangCareSolutionsLtd_ApplicationPack_v2.docx"
                        class="file-download-app-pack-btn btn btn-primary btn-lg"
                        ><span
                          class="fa fa-cloud-download file-download-app-pack-btn-logo"
                          role="button"
                        ></span
                        ><span class="file-download-app-pack-btn-text"
                          >Download</span
                        ></a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import ApplicationForm from "./ApplicationForm";
export default {
  components: {
    ApplicationForm,
  },
  props: ["id"],
};
</script>
<style scoped>
.app-job-details {
  font-weight: 400;
}
.app-job-details .panel-title {
  font-size: 20px;
}
.app-job-details .panel-title i {
  margin-right: 10px;
}
</style>
